
// Re-export from the hook implementation
import { useToast, toast } from "@/hooks/use-toast";

export { useToast, toast };
